/**
 * GelBand Component
 *
 * Description:
 * The GelBand component represents a band on a gel electrophoresis visualization.
 * It provides UI representation for the band and allows users to control its position if controls are enabled.
 *
 * Import Dependencies:
 */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import GelBandControls from "./controls";
import styles from "./style.module.scss";

class GelBand extends React.Component {
  render() {
    const { id, position, color, type, component_type, lane, controls } =
      this.props;

    // Dynamic class assignment based on component properties.
    const laneClassName = `${styles.Lane} ${
      styles[`Lane-${type}-${component_type}-${lane}`]
    }`;
    const transformPosition =
      component_type === "predicts" ? position : (position * 238) / 333;
    return (
      <div className={laneClassName}>
        {/* Visualization of the Gel Band */}
        <div
          className={styles.Particle}
          style={{
            transform: `translate3d(0px, ${transformPosition}px, 0px) rotateZ(0deg)`,
            background: color,
            boxShadow: `0px 0px 4px ${color}`,
          }}
        >
          {/* Gel Band Controls */}
          {controls && (
            <GelBandControls
              type={type}
              color={color}
              lane={lane}
              id={id}
              position={position}
            />
          )}
        </div>
      </div>
    );
  }
}

// Prop type validation for the component.
GelBand.propTypes = {
  id: PropTypes.number.isRequired,
  position: PropTypes.number,
  color: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  component_type: PropTypes.string.isRequired,
  lane: PropTypes.number.isRequired,
  controls: PropTypes.bool.isRequired,
};

// Default prop values for the component.
GelBand.defaultProps = {
  position: 0,
};

/**
 * Maps the state from the Redux store to the component props.
 * @param {object} state - The current state from the Redux store.
 * @param {object} ownProps - The props passed to the component.
 * @returns {object} - Returns the mapped props.
 */
function mapStateToProps(state, ownProps) {
  const gelData = state.gel[ownProps.type][ownProps.id];
  return gelData ? { ...gelData } : { ...ownProps };
}

// Connect the component to the Redux store.
export default connect(mapStateToProps)(GelBand);
